import React from "react";
import PropTypes from "prop-types";
import Card from "reactstrap/lib/Card";
import CardHeader from "reactstrap/lib/CardHeader";
import CardBody from "reactstrap/lib/CardBody";
import Collapse from "reactstrap/lib/Collapse";

import Icon from "../icon/icon";
import { ArrowRight } from "../../lib/icons";
import { gatherClasses, isFunction } from "../../lib/utils";
import "./accordion.scss";

class Accordion extends React.Component {
  onItemChange = item => {
    const { activeItemId, onItemChange } = this.props;
    let id = null;
    if (item.id !== activeItemId) {
      id = item.id;
    }
    onItemChange(id);
  };

  render() {
    const { dataTestId, items, activeItemId } = this.props;

    return (
      <div
        data-testid={dataTestId}
        className={gatherClasses(this.props, "oui-accordion")}
      >
        {items.map(item => {
          return (
            <Card
              key={item.id}
              className={gatherClasses(
                null,
                "oui-accordion-card",
                item.id === activeItemId
                  ? "oui-card-expanded"
                  : "oui-card-collapsed"
              )}
            >
              <CardHeader
                className="oui-accordion-card-header"
                onClick={() => this.onItemChange(item)}
              >
                {item.icon ? (
                  React.isValidElement(item.icon) ? (
                    React.cloneElement(item.icon, {
                      className: gatherClasses(
                        null,
                        "oui-mr-3",
                        item.icon.props.className
                      )
                    })
                  ) : (
                    <Icon {...item.icon} />
                  )
                ) : null}
                <span className="oui-title oui-text-truncate">
                  {item.title}
                </span>
                <Icon
                  src={ArrowRight}
                  width="12px"
                  height="12px"
                  clickable
                  onClick={this.onCollapseToggle}
                  className={gatherClasses(null, "oui-card-collapse-toggler")}
                />
              </CardHeader>
              <Collapse isOpen={item.id === activeItemId}>
                <CardBody
                  className={gatherClasses(
                    null,
                    "oui-accordion-card-body",
                    item.noGutter ? "oui-p-0" : null
                  )}
                >
                  {isFunction(item.component) && item.component()}
                </CardBody>
              </Collapse>
            </Card>
          );
        })}
      </div>
    );
  }
}

Accordion.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string,
      icon: PropTypes.any,
      component: PropTypes.func,
      noGutter: PropTypes.bool
    })
  ),
  activeItemId: PropTypes.string,
  onItemChange: PropTypes.func,
  dataTestId: PropTypes.string
};

Accordion.defaultProps = {
  items: [],
  onItemChange: () => {},
  dataTestId: "orion-accordion"
};

Accordion.displayName = "OrionAccordion";

export default Accordion;
